import SpainContributionType from 'modules/contracts/store/models/SpainContributionType'

import { PayrollLegalEntityResource } from 'modules/contracts/store/collections/payrollLegalEntityResource'

class ContributionTypes extends PayrollLegalEntityResource<SpainContributionType> {
  get cacheKey(): string {
    return 'contributionTypes'
  }

  model() {
    return SpainContributionType
  }
}

export { ContributionTypes }
